// TrackerGTM.jsx (você pode criar esse arquivo ou definir o componente no mesmo arquivo do router)
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TrackerGTM = () => {
  const location = useLocation();

  useEffect(() => {
    // Certifique-se de que o dataLayer esteja definido
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pageview',
      page: location.pathname,
    });
  }, [location]);

  return null;
};

export default TrackerGTM;
